import React, { ReactNode } from "react";
import { Box, styled, Typography } from "@mui/material";

import {
  borderRadius,
  borderSize,
  colors,
  fontFamily,
  fontSize,
  fontWeight,
  gaps,
  padding,
} from "theme/defaultStyle";
import { ReportProblem } from "@mui/icons-material";

// Tints of colors.orange -- kept local until the theme exposes warning surface tokens.


const Container = styled(Box)({
  alignItems: "center",
  backgroundColor: colors.orange02,
  border: `${borderSize.xsmall} solid ${colors.orange03}`,
  borderRadius: borderRadius.small,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "row",
  gap: gaps.small3,
  padding: `${padding.medium1} ${padding.large1}`,
  width: "100%",
  "& .warningIcon": {
    color: colors.orange03,
    flexShrink: 0,
    fontSize: fontSize.xlarge,
  },
});

const Message = styled(Typography)({
  color: colors.orange01,
  fontFamily: fontFamily.primary,
  fontSize: fontSize.medium,
  fontStyle: "normal",
  fontWeight: fontWeight.bold1,
  lineHeight: "normal",
});

type WarningBannerProps = {
  children?: ReactNode;
  className?: string;
  message?: ReactNode;
};

const WarningBanner = ({ children, className, message }: WarningBannerProps) => (
  <Container className={className} role="alert">
    <ReportProblem className="warningIcon" />
    <Message>{message ?? children}</Message>
  </Container>
);

export default WarningBanner;
